import React, { useRef } from 'react';
import { ITableColumn } from '../../../../Models/Table/ITableColumn';
import { joinClasses } from '../../../../Utils/className.util';
import useScrollableDataTableFixedItems from '../../Hooks/useScrollableDataTableFixedItems';
// @ts-ignore
import styles from './ScrollableDataTable.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	columns: ITableColumn[];
	firstColumnFixed?: boolean;
}

const ScrollableDataTableHead: React.FC<Props> = ({
	columns,
	firstColumnFixed = true,
}) => {
	const headRef = useRef<any>();
	const { fixedItems } = useScrollableDataTableFixedItems({
		ref: headRef,
		firstColumnFixed,
	});
	const { t } = useTranslation();

	return (
		<thead className={styles.thead} ref={headRef}>
			<tr className={styles.tr}>
				<>
					{fixedItems && (
						<th
							style={{
								minHeight: fixedItems[0].height,
								minWidth: fixedItems[0].width,
								maxHeight: fixedItems[0].height,
								maxWidth: fixedItems[0].width,
								height: fixedItems[0].height,
								width: fixedItems[0].width,
							}}
							className={joinClasses([styles.th, styles.fixed])}>
							{columns[0].title}
						</th>
					)}
				</>
				{columns.map((column: ITableColumn, index: number) => {
					return (
						<th key={index} className={joinClasses([styles.th])}>
							{column.title && t(column.title)}
						</th>
					);
				})}
			</tr>
		</thead>
	);
};
export default ScrollableDataTableHead;
